import angular from 'angular';
import uiRouter from 'angular-ui-router';
import postComponent from './post.component';
import postFactory from './post.factory';

const postModule = angular
  .module('post', [uiRouter])
  .component('post', postComponent)
  .factory('Post', postFactory)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('main.post', {
      url: '/post?user&titile',
      component: 'post',
    });
  }).name;

export default postModule;



// WEBPACK FOOTER //
// ./client/app/components/post/post.js